import { RadioInputProps } from './interface'

export function withRadioInput(Component: React.FC<RadioInputProps>) {
  function WithRadioInput(props: RadioInputProps) {
    return <Component {...props} />
  }

  return WithRadioInput
}
